import { render, staticRenderFns } from "./MagentaText.vue?vue&type=template&id=6c61c300&scoped=true&"
import script from "./MagentaText.vue?vue&type=script&lang=ts&"
export * from "./MagentaText.vue?vue&type=script&lang=ts&"
import style0 from "./MagentaText.vue?vue&type=style&index=0&id=6c61c300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61c300",
  null
  
)

export default component.exports